import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import IconRadiusButton from '../../CustomizedUIs/IconRadiusButton';
import { ArrowBack } from '@material-ui/icons'

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    textDecoration: 'none',
    cursor: 'pointer'
  },
  backTitle: {
    fontFamily: 'UniviaPro-Medium',
    fontSize: 15,
    lineHeight: 1.2,
    color: theme.palette.primary.light,
    margin: 'auto 0'
  }
}));

function DialogBackButton({ onBack, label }) {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Box className={classes.container} onClick={onBack}>
      <Box display='flex' mr={2}>
        <IconRadiusButton style={{ margin: 'auto', color: 'white', padding: '6px' }} bgColor={theme.palette.primary.main}>
          <ArrowBack />
        </IconRadiusButton>
      </Box>
      <Typography className={classes.backTitle}>{label}</Typography>
    </Box>
  );
}

DialogBackButton.propTypes = {
  label: PropTypes.string.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default DialogBackButton;
